
import { toast } from 'sonner';

// Define the payment status type that's being used in other components
export type PaymentStatus = 'pending' | 'processing' | 'succeeded' | 'failed';

// Define the CardDetails type that's being used in other components
export interface CardDetails {
  cardNumber: string;
  cardholderName: string;
  expiryDate: string;
  cvv: string;
  saveCard?: boolean; // Add the optional saveCard property
}

// Define the payment result interface
export interface PaymentResult {
  success: boolean;
  transactionId?: string;
  error?: string;
}

// Simple function to process Stripe payments
export const processStripePayment = async (
  cardDetailsOrAmount: CardDetails | number, 
  recipientId: string
): Promise<PaymentResult> => {
  try {
    // Check if first argument is a number (amount) or an object (card details)
    const isCardDetails = typeof cardDetailsOrAmount !== 'number';
    
    if (isCardDetails) {
      // Process with card details
      const cardDetails = cardDetailsOrAmount as CardDetails;
      console.log(`Processing Stripe payment with card ending in ${cardDetails.cardNumber.slice(-4)} to recipient ${recipientId}`);
    } else {
      // Process with just amount
      const amount = cardDetailsOrAmount as number;
      console.log(`Processing Stripe payment of $${amount} to recipient ${recipientId}`);
    }
    
    // Simulate successful payment processing
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Generate a mock transaction ID
    const transactionId = `tx_${Date.now()}`;
    
    return { 
      success: true,
      transactionId 
    };
  } catch (error) {
    console.error('Stripe payment error:', error);
    toast.error('Payment processing failed');
    return { 
      success: false,
      error: error.message || 'An unexpected error occurred'
    };
  }
};
